import { useState } from "react";

const Stepper = ({getTitleClass,currentPage}) => {
    

    return ( 
      <>


<div className="d-flex align-items-center justify-content-center gap-3">
  {[1, 2, 3].map((step, index) => (
    <div key={step} className={`step ${getTitleClass(step)}`}>
      <button
        type="button"
        className="step-trigger"
        disabled={step > currentPage} // assuming you have `currentStep` in state
      >
        <span className="bs-stepper-circle">{step}</span>
      </button>

      {/* Only show arrow if it's not the last step */}
      {step < 3 && (
        <span className="mx-2 text-muted">
          <i className="bx bx-chevron-right fs-4" />
        </span>
      )}
    </div>
  ))}
</div>



      <div className="bs-stepper-header d-none">
        <div className={`step ${getTitleClass(1)}`}>
          <button type="button" className="step-trigger">
            <span className="bs-stepper-circle">1</span>
            {/* <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Personal Information</span>
              <span className="bs-stepper-subtitle">Fill-up details</span>
            </span> */}
          </button>
        </div>
        <div className="line">
          <i className="bx bx-chevron-right" />
        </div>
        <div className={`step ${getTitleClass(2)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">2</span>
            {/* <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Requirements</span>
              <span className="bs-stepper-subtitle">Upload Requirements & Documents</span>
            </span> */}
          </button>
        </div>


        <div className="line">
          <i className="bx bx-chevron-right" />
        </div> 
        <div className={`step ${getTitleClass(3)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">3</span>
            {/* <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Review & Save</span>
              <span className="bs-stepper-subtitle">Lawyer & Notarial Information</span>
            </span> */}
          </button>
        </div>
      </div>

      </>
     );
}
 
export default Stepper;